/* src/components/create-update-company-modal/create-update-company-modal.component.scss */
:host {
  display: block;
}
.member {
  table-layout: auto;
  width: 100%;
  margin: 0 0 1.8rem 0;
}
.member__col--options,
.member__col--admin-rights,
.member__col--edit-rights {
  width: 1px;
  white-space: nowrap;
}
.member__col--name {
  word-break: break-all;
}
.add-row {
  display: table;
  table-layout: auto;
  width: 100%;
}
.add-row__input {
  display: table-cell;
  vertical-align: top;
  text-align: left;
}
.add-row__input--submit {
  width: 1px;
  white-space: nowrap;
  padding-left: 0.6rem;
}
.radio-group {
  margin-top: 40px;
  margin-left: -30px;
  display: block;
}
/*# sourceMappingURL=create-update-company-modal.component-FCUXN7O3.css.map */
